import { CalendarRepository } from '../Repositories/CalendarRepository';
import getProcessedFreeSlots from '../Utility/getProcessedFreeSlots';
import { setApiStatus } from './ApiStatusActions';

const calendarRepository = new CalendarRepository();

function createEvent(event) {
  return (dispatch) => {
    calendarRepository.createEvent(event).then((response) => {
      dispatch({
        type: 'CREATE_EVENT',
        payload: event,
        eventId: response.data.EventId,
      });
    });
  };
}

function fetchEvents(timeSlot) {
  return (dispatch) => {
    calendarRepository.getEvents(timeSlot).then((response) => {
      dispatch({
        type: 'GET_ARYA_EVENTS',
        payload: response.data,
        startTime: timeSlot.start_date,
        endTime: timeSlot.end_date,
      });
    });
  };
}

function fetchBusySlots(timeSlot) {
  return (dispatch) => {
    calendarRepository.getBusySlots(timeSlot).then((response) => {
      dispatch({
        type: 'GET_BUSY_SLOTS',
        payload: response.data,
      });
    });
  };
}

function updateEvent(details, update) {
  return (dispatch) => {
    calendarRepository.updateEvent(details).then(() => {
      if (update === 'Propose') {
        dispatch({
          type: 'PROPOSE_EVENT',
          payload: details,
        });
      } else {
        dispatch({
          type: 'ACCEPT_OR_DECLINE_EVENT',
          payload: details,
        });
      }
    });
  };
}

function fetchCollisionEventsCount(timeSlot, checkOverlapWithOldTime, callback) {
  return () => {
    calendarRepository.getEvents(timeSlot).then((response) => {
      if (checkOverlapWithOldTime) {
        callback(response.data.length - 1);
      } else {
        callback(response.data.length);
      }
    });
    calendarRepository.getBusySlots(timeSlot).then((response) => {
      callback(response.data.length);
    });
  };
}

function deleteEvent(event) {
  return (dispatch) => {
    calendarRepository.deleteEvent(event.EventId).then(() => {
      dispatch({
        type: 'DELETE_EVENT',
        payload: event,
      });
    });
  };
}

function addFreeSlotsByDate(freeSlots) {
  return {
    type: 'ADD_FREE_SLOTS_BY_DATE',
    payload: freeSlots,
  };
}

function fetchFreeSlots(interval, type, userIds) {
  return async (dispatch) => {
    dispatch(setApiStatus({
      apiName: 'GetFreeSlots',
      status: 'INPROGRESS',
    }));
    try {
      const freeSlots = await calendarRepository.getFreeSlots(interval, type, userIds);
      const processedFreeSlots = getProcessedFreeSlots(freeSlots.data);
      dispatch(addFreeSlotsByDate(processedFreeSlots));
      dispatch(setApiStatus({
        apiName: 'GetFreeSlots',
        status: 'COMPLETED',
      }));
    } catch (error) {
      dispatch(setApiStatus({
        apiName: 'GetFreeSlots',
        status: 'FAILED',
      }));
    }
  };
}

function getEventById(eventId) {
  return async (dispatch) => {
    dispatch(setApiStatus({
      apiName: 'getEventById',
      status: 'INPROGRESS',
    }));
    const event = await calendarRepository.getEventById(eventId);
    dispatch({
      type: 'SET_EVENT_BY_ID',
      payload: {
        eventId,
        event,
      },
    });
    dispatch(setApiStatus({
      apiName: 'getEventById',
      status: 'COMPLETED',
    }));
  };
}

function updateEventById(eventId, event) {
  return async () => {
    await calendarRepository.updateEventById(eventId, event);
  };
}

export {
  createEvent,
  fetchEvents,
  updateEvent,
  deleteEvent,
  fetchBusySlots,
  fetchFreeSlots,
  getEventById,
  fetchCollisionEventsCount,
  updateEventById,
};
